import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { authApi, RoleEntity } from "@/api/auth";

export interface RoleState {
  roles: RoleEntity[];
}

const roleModule: Module<RoleState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      roles: [] as RoleEntity[]
    } as RoleState),
  mutations: {
    setRoles(
      state: RoleState,
      roles: RoleEntity[]
    ): void {
      state.roles = roles;
    }
  },
  actions: {
    async listAll(
      context: ActionContext<RoleState, RootState>
    ): Promise<void> {
      if (
        !context.state.roles ||
        context.state.roles.length === 0
      ) {
        context.commit(
          "setRoles",
          await authApi.listRoles()
        );
      }
    },
    async add(
      context: ActionContext<RoleState, RootState>,
      roleEntity: RoleEntity
    ): Promise<void> {
      await authApi.addRole(roleEntity);
      context.commit(
        "setRoles",
        await authApi.listRoles()
      );
    },
    async edit(
      context: ActionContext<RoleState, RootState>,
      roleEntity: RoleEntity
    ): Promise<void> {
      if (roleEntity.id) {
        await authApi.editRole(roleEntity);
        context.commit(
          "setRoles",
          await authApi.listRoles()
        );
      }
    },
    async remove(
      context: ActionContext<RoleState, RootState>,
      roleEntity: RoleEntity
    ): Promise<void> {
      if (roleEntity.id) {
        await authApi.deleteRole(roleEntity);
        context.commit(
          "setRoles",
          await authApi.listRoles()
        );
      }
    }
  }
};

export default roleModule;
